// extracted by mini-css-extract-plugin
export default {"root":"uLpeVNQabGVKyxpJQvvb","body":"wiH6j2ReIZzBfUspj89R","modal":"jEAjjadFqnwD_ZISoY57","btn":"yfP0X5kfrAc4gCUmiw9F","btns":"ESshXNRyKepKev7pSuKE","message":"gPSe5pu75klw1KW7Gr7L"};